export default class{
	namespace = '';
	constructor(namespace){
		this.namespace = namespace?namespace:'';
		return {getItem:this.getItem,setItem:this.setItem,removeItem:this.removeItem}
	}
	getItem = (key)=>{
		key = this.namespace?this.namespace+'-'+key:key;
		let res = localStorage.getItem(key);
		return res;
	}
	setItem = (key,val)=>{
		key = this.namespace?this.namespace+'-'+key:key;
		localStorage.setItem(key,val);
	}
	removeItem = (key)=>{
		key = this.namespace?this.namespace+'-'+key:key;
		localStorage.removeItem(key);
	}
}